import { QueryItem } from '@/types/query';

export interface InvitationPromotionQueryConfig {
    queryItems: QueryItem[];
    requireAllFields?: boolean;
}

// Query
export interface InvitationLinkQueryParams {
    customerUID: string; // agent_id
    customerGroup: number; // group_id
    transactionTime: [number, number]; // time_range
}

export interface InvitationReviewRecordQueryParams {
    customerUID: string; // agent_id
    type: number; // type
}

//
export interface InvitationLink {
    link?: string; // invite_link = base + invite_code
    code: string; // invite_code
    isDefault?: boolean; // first is default
    spot: number; // spot_rebate_rate
    futures: number; // contract_rebate_rate
    alpha?: number;
    linkLocation: string; // channel_tag
    clickCount: number; // click_count
    registrationCount: number; // registration_count
    depositCount: number; // deposit_count
    tradeCount: number; // trade_count
    tradingVolume: number; // total_volume
    rebateAmount: number; // total_commission
    registrationType: number; // custom_page_id number to label mapping
    remarks?: string;
}

export const base_invitation_link = 'https://app.qubit.trade/join/';

export interface InvitationLinkSettings {
    invitationLink: {
        spot: number; // spot_rebate_rate
        futures: number; // contract_rebate_rate
        alpha?: number;
        web3?: number;
        // Invitation link
        link?: string; // invite_link = base + invite_code
        // Invitation code
        code: string; // invite_code
        // Registration page type
        registrationType: number; // custom_page_id number to label mapping
        remarks: string; // 
    };
    dataOverview: {
        rebateAmount: number; // total_commission
        tradingVolume: number; // total_volume
        numberOfClicks: number; // click_count
        numberOfInvites: number; // registration_count
        numberOfTraders?: number; // deposit_count
        numberOfDepositors?: number; // trade_count
    };
}

export interface InvationV13SummaryResponse { // Invite Friend / Share link dialog
  bind:boolean;// 是否绑定邀请码
  referral_rate: string; // 邀请比例
  referral_code: string; // 邀请码
  invited: number; // 推荐人数
  rewards: string; // 获得的奖励
  // need discount rate
}

export interface RegistrationPage {
    name: string; // page_name
    avatarImage?: string;
    username?: string;
    isLongTerm: boolean; // is_long_term
    validity?: string[]; // [start_date, end_date]
    creationTime: string; // created_at
    linkCount?: number; // invite_count
    isHidden: boolean; // is_hidden
    profileInfo: string; // introduction
    status?: string; // status
    templateId?: number; // template_id
    eventImage?: string;
    eventLink?: number;
    default?: boolean; // is_default
}

export interface RegistrationPageDetails {
    name: string;  // page_name
    isHidden: boolean;
    avatarImage?: string;
    username?: string;
    introduction?: string;
    recommendedImageMaterials?: number; // template_id
    eventImage?: string;
    isLongTerm: boolean;
    validity?: string[];   // validity period in unix timestamp
    eventLink?: number;
    creationTime?: string; // created_at
    default: boolean; // is_default
}

export interface RegistrationPageImageMaterial {
    id: number; // template_id
    previewImage: string; // preview_image
    templateName?: string; // template_name
}

export interface InvitationReview {
    submissionTime: string;
    customerUID: string,
    type: string, // number,
    spot_rebate_rate?: number,
    contract_rebate_rate?: number,
    alpha?: number,
    status: string,
    reason: string,
}

export interface LinkListResponse {
    list: InvitationLink[];
    total: number;
}

export interface RegistrationPageListResponse {
    list: RegistrationPage[];
    total: number;
}

export interface InvitationReviewListResponse {
    list: InvitationReview[];
    total: number;
}
